import { createContext } from 'react';
export const backgroundContext = createContext(undefined);
//# sourceMappingURL=BackgroundContext.js.map